import React from 'react';
import { User, Mail, Phone, Calendar } from 'lucide-react';

const StudentProfileWidget = ({ userData }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-4">
        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
          <User className="w-10 h-10 text-blue-600" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900">
            {userData.firstName} {userData.fatherName} {userData.surname}
          </h3>
          <p className="text-gray-600">{userData.rollNumber}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="flex items-center space-x-2">
          <Mail className="w-4 h-4 text-gray-400" />
          <span>{userData.email}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Phone className="w-4 h-4 text-gray-400" />
          <span>{userData.mobile}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Calendar className="w-4 h-4 text-gray-400" />
          <span>DOB: {userData.dob}</span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="font-medium">Division/Batch:</span>
          <span>{userData.division} / {userData.batch}</span>
        </div>
      </div>
    </div>
  );
};

export default StudentProfileWidget;